export const LOADER_STATUS = "boilderplate/ITC04/UploadPage/LOADER_STATUS";
export const FILE_DATA = "boilderplate/ITC04/UploadPage/FILE_DATA";
export const SAVE_TOTAL_PAGES = 'boilderplate/Gstr6/UploadPage/SAVE_TOTAL_PAGES';